module.exports = __webpack_public_path__ + "static/media/uoft.0505dd4f.jpeg";